/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import DbBaseObject from "@shared/DbBaseObject.js";



export default class ClientProfileRef extends DbBaseObject{

	coachId: string = null
	clientId: string = null
	clientProfileIdForCoach: string = null


	constructor(coachId: string = null, clientId: string = null, clientProfileIdForCoach: string = null) {
		super();
		this.coachId = coachId;
		this.clientId = clientId;
		this.clientProfileIdForCoach = clientProfileIdForCoach || null;
	}
}
